import { create } from 'zustand';
import { 
  addDays, addMonths, addYears, 
  startOfDay, endOfDay, 
  startOfMonth, endOfMonth, 
  startOfYear, endOfYear,
  format
} from 'date-fns';

/**
 * Dashboard Store - Centraliza el estado de fechas y filtros
 * Compartido entre DashboardPage y RentabilidadPage
 */
const useDashboardStore = create((set, get) => ({
  // === STATE ===
  selectedDate: new Date(),
  viewMode: 'monthly', // 'daily' | 'monthly' | 'yearly'
  
  // === ACTIONS ===
  setSelectedDate: (date) => set({ 
    selectedDate: typeof date === 'string' ? new Date(date + 'T12:00:00') : date 
  }),
  
  setViewMode: (mode) => set({ viewMode: mode }),
  
  nextPeriod: () => {
    const { selectedDate, viewMode } = get();
    let newDate;
    
    switch (viewMode) {
      case 'daily':
        newDate = addDays(selectedDate, 1);
        break;
      case 'monthly':
        newDate = addMonths(selectedDate, 1);
        break;
      case 'yearly':
        newDate = addYears(selectedDate, 1);
        break;
      default:
        newDate = addMonths(selectedDate, 1);
    }
    
    set({ selectedDate: newDate });
  },
  
  prevPeriod: () => {
    const { selectedDate, viewMode } = get();
    let newDate;
    
    switch (viewMode) {
      case 'daily':
        newDate = addDays(selectedDate, -1);
        break;
      case 'monthly':
        newDate = addMonths(selectedDate, -1);
        break;
      case 'yearly':
        newDate = addYears(selectedDate, -1);
        break;
      default:
        newDate = addMonths(selectedDate, -1);
    }
    
    set({ selectedDate: newDate });
  },
  
  resetDate: () => set({ selectedDate: new Date() }),
  
  // === COMPUTED GETTERS ===
  getDateRange: () => {
    const { selectedDate, viewMode } = get();
    
    switch (viewMode) {
      case 'daily':
        return {
          startDate: format(startOfDay(selectedDate), 'yyyy-MM-dd'),
          endDate: format(endOfDay(selectedDate), 'yyyy-MM-dd')
        };
      case 'monthly':
        return {
          startDate: format(startOfMonth(selectedDate), 'yyyy-MM-dd'),
          endDate: format(endOfMonth(selectedDate), 'yyyy-MM-dd')
        };
      case 'yearly':
        return {
          startDate: format(startOfYear(selectedDate), 'yyyy-MM-dd'),
          endDate: format(endOfYear(selectedDate), 'yyyy-MM-dd')
        };
      default:
        return {
          startDate: format(startOfMonth(selectedDate), 'yyyy-MM-dd'),
          endDate: format(endOfMonth(selectedDate), 'yyyy-MM-dd')
        };
    }
  },
  
  // Formato de fecha para inputs HTML (YYYY-MM-DD)
  getDateValue: () => {
    const { selectedDate } = get();
    return format(selectedDate, 'yyyy-MM-dd');
  },
  
  // Para API call params
  getFilterParams: () => {
    const { viewMode } = get();
    const { startDate, endDate } = get().getDateRange();
    return {
      filter_type: viewMode,
      start_date: startDate,
      end_date: endDate
    };
  }
}));

export default useDashboardStore;
